
import { Component, Prop, Vue } from "vue-property-decorator";
import httpClient from "@/store/httpClient";
import { UserDto } from "@/dtos/userDto";
import { UserClaimDto } from "@/dtos/userClaimDto";
import rules from "@/store/rules";

@Component({})
export default class UserTile extends Vue {
	@Prop()
	private user!: UserDto;
	private lastUser: UserDto = new UserDto();
	private isValid: boolean = false;
	private isLoading: boolean = false;
	private requiredStringMax35Rule = rules.requiredStringMax35Rule;

	private mounted() {
		this.lastUser = JSON.parse(JSON.stringify(this.user));
	}

	private get hasChanges() {
		return (
			this.lastUser.firstname !== this.user.firstname ||
			this.lastUser.lastname !== this.user.lastname ||
			this.lastUser.phone !== this.user.phone ||
			this.lastUser.funktion !== this.user.funktion ||
			this.lastUser.newsletterSubscribed !== this.user.newsletterSubscribed
		);
	}

	private async saveClaim(
		userId: string,
		username: string,
		claimType: string,
		claimValue: boolean
	) {
		console.log(`Setting claim ${claimType} to ${claimValue} for user ${username}...`);
		try {
			let claimDto: UserClaimDto = {
				userId: userId,
				username: username,
				claimType: claimType,
				claimValue: claimValue ? "true" : "false",
			};
			const response = await httpClient().post("Customer/SaveUserClaim", claimDto);
			if (response.status === 200) {
				this.$store.commit("setSnackbarText", "Berechtigung erfolgreich gespeichert.");
			} else {
				throw `Error status code: ${response.status}`;
			}
		} catch (err) {
			console.log("Error while saving user claim", err);
			this.$store.commit("setSnackbarErrorText", "Fehler beim Speichern der Berechtigung.");
		}
	}

	private async saveUser() {
		if (this.isValid && !this.isLoading && this.hasChanges) {
			try {
				this.isLoading = true;
				const response = await httpClient().post("Customer/SaveUser", this.user);
				if (response.status === 200) {
					this.$store.commit("setSnackbarText", "Benutzerdaten erfolgreich gespeichert.");
					this.lastUser = JSON.parse(JSON.stringify(this.user));
				} else {
					throw `Error status code: ${response.status}`;
				}
			} catch (err) {
				console.log("Error while saving user data", err);
				this.$store.commit(
					"setSnackbarErrorText",
					"Benutzerdaten konnten nicht gespeichert werden."
				);
			} finally {
				this.isLoading = false;
			}
		}
	}

	private async getLoginCode() {
		try {
			this.isLoading = true;
			const response = await httpClient().get(
				`User/getLoginCode?username=${encodeURIComponent(this.user.eMail)}`
			);
			const link = document.createElement("a");
			var url = process.env.VUE_APP_KUNDENPORTAL_URL;
			if (url !== undefined) {
				url = url.substr(0, url.length - 3);
				link.href = `${url}?signInUser=${encodeURIComponent(response.data)}`;
			}
			link.setAttribute("target", "_blank");
			link.click();
			this.$store.commit("setSnackbarText", "Logincode erfolgreich geladen.");
		} catch {
			this.$store.commit("setSnackbarErrorText", "Logincode konnte nicht geladen werden.");
		}
	}
}
